import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { NoteStore } from '@store';

import { InputValuePipe } from '../../../../../shared/pipes/input-value/input-value.pipe';

@Component({
  selector: 'app-note-modal',
  templateUrl: './note-modal.component.html',
  styleUrls: ['./note-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoteModalComponent implements OnInit {
  note: string;
  newNote: string;
  installationId: string;
  isEditNote: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { installationId: string; note?: string },
    public dialogRef: MatDialogRef<NoteModalComponent>,
    private noteStore: NoteStore,
    private inputValuePipe: InputValuePipe
  ) {}

  ngOnInit(): void {
    this.installationId = this.data.installationId;
    this.note = this.data.note;
    this.isEditNote = !!this.data.note;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    if (this.newNote) {
      this.noteStore.addNote(this.installationId, this.newNote);
      this.dialogRef.close({
        action: 'new-note',
        note: this.newNote,
      });
    }
  }

  getValue(event: Event): string {
    return this.inputValuePipe.transform(event);
  }
}
